module.exports = __webpack_public_path__ + "1791188489487/fonts/Metropolis-Bold.87cfcb6.woff2";